import { trimRight } from "./stringHelpers";

export const parseFloatWithDefault = (text: string, defaultValue?: number) => {
    var retVal = Number.parseFloat(text);
    if (Number.isNaN(retVal))
        return defaultValue;
    return retVal;
}

export const toOrdinalString = (num: number) => {
    if (num <= 0)
        return "0";
    const sfx = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (sfx[(v - 20) % 10] || sfx[v] || sfx[0]);
}

export const toFixedMax = (num: number, maxDigits: number) => {
    if (num === undefined || num === null) return "";

    const retVal = num.toFixed(maxDigits);
    return trimRight(trimRight(retVal, "0"), ".");
}

/**
 * Formats a bits-per-second rate (DvrBitrateBps, VideoBitrateBps, x264enc targets).
 * These are BITS, not bytes — routing them through a byte formatter overstates them
 * 8x and reads as "4 MB/s" for a 4 Mb/s stream.
 */
export const formatBitrate = (bitsPerSecond?: number | null) => {
    if (!bitsPerSecond) return "—";
    const k = 1000;
    const units = ["b/s", "Kb/s", "Mb/s", "Gb/s", "Tb/s"];
    const i = Math.min(Math.floor(Math.log(Math.abs(bitsPerSecond)) / Math.log(k)), units.length - 1);
    return `${toFixedMax(bitsPerSecond / Math.pow(k, i), 2)} ${units[i]}`;
}

export const MaxServerIntValue = 2147483647;